import type { OrganizationsListTableRowActionsProps } from "./organizations-list-table-row-actions.type";

import { useListTableRowActions } from "@/modules/list-table-row-actions";
import ModelDeleteButton from "@/modules/model-delete-button";
import { OrganizationEditButton } from "@/modules/organization/organization-edit-button";
import { OrganizationInfoButton } from "@/modules/organization/organization-info-button/organization-info-button.component";

export const OrganizationsListTableRowActions = ({
  organization,
}: OrganizationsListTableRowActionsProps) => {
  const { closePopover } = useListTableRowActions();

  return (
    <>
      <OrganizationInfoButton organization={organization} />
      <OrganizationEditButton organization={organization} />
      <ModelDeleteButton
        type="text"
        modelKey="organization"
        item={organization}
        onClick={closePopover}
        hideIcon
      />
    </>
  );
};
